$(function() {

	// console.log("hey");

	//     $('body').on('scroll', function(e){
	//     	console.log(e);
	//         if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
	//             alert('end reached');
	//         }
	//     });

	// $(window).on('scroll', function(e){
	//         // if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
	//         //     alert('end reached');
	//         // }   

	//         console.log($(this).scrollTop(),$(this).innerHeight(),$('.gallery-section')[0].scrollHeight);

	//         if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
	//             alert('end reached');
	//         }    	
	// });	




	/* Helper Functions */

	//debouncer

	var waitForFinalEvent = (function () {
		var timers = {};
		return function (callback, ms, uniqueId) {
			if (!uniqueId) {
				uniqueId = "Don't call this twice without a uniqueId";
			}
			if (timers[uniqueId]) {
				clearTimeout (timers[uniqueId]);
			}
			timers[uniqueId] = setTimeout(callback, ms);
		};
	})(); 

	/* end of debouncer */	


	/* Shrink Header On Scroll */
	// console.log($('.body-wrapper').height(), $('.body-wrapper').innerHeight(),$(window).height(), $(window).innerHeight());
	// if($('body').height() > $(window).height()){
		$(document).on('scroll', function(){
			// waitForFinalEvent(function(){
				
				if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
					$('.body-wrapper').addClass('scrolled');
				} else {
					$('.body-wrapper').removeClass('scrolled');
				}

			// }, 200, "shrinking header");
		});
	// }

	$(document).on('click', '#menu-btn', function (e) {
	  e.preventDefault();
	  $(this).toggleClass('active');
	  // $('.site-header-mobile nav').fadeIn();
	  $('body').toggleClass('lock');
	  $('.site-header').toggleClass('active');
	  if (!$(this).hasClass('active')) {
	    // $('.site-header-mobile nav').fadeOut();
	  }

	});


	/* Gallery Page */

	function galleryShowMore(className,amount) {
		$(className).slice(0, amount).each( function ( index, element ){
			$(this).fadeIn('slow');
			$(this).delay(4000).removeClass('hidden');
		});
	}

	if(!!$('.gallery-section').length){

		$(".gallery-item-wrapper.hidden").slice(0, 9).each( function ( index, element ){
				$(this).removeClass('hidden');
			});		

		$(document).on('scroll', function(){

			waitForFinalEvent(function(){

				if(($(window).scrollTop() + $(window).height()) > $('.gallery-section .loader').offset().top) { 	

					if($('.gallery-item-wrapper.hidden').length > 0) {

						$('.loader').removeClass('hidden');

						setTimeout(function(){ $('.loader').addClass('hidden'); }, 1000);
						setTimeout(function(){galleryShowMore('.gallery-item-wrapper.hidden',3);$.fn.matchHeight._update();}, 1000)


					}
					console.log('end reached');
				}

	  		}, 350, "loading more gallery images");

		});
	}

	$('.home-carousel-j').slick({
		autoplay: true,
		infinite: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false
	});

	$('.media-carousel-j').slick({
		autoplay: true,
		autoplaySpeed: 10000,
		infinite: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		appendArrows: $('.mj-arrows')
	});

	$('.j-rc').slick({
		autoplay: true,
		infinite: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false
	});

	$(document).on('click', '.j-menu', function(e){
	
		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');
		var menu = $(this).data('menu');
		$('.menu-block').hide();
		$('.j-menu-' + menu +'').show();
		$("html, body").animate({ scrollTop: 0 }, 500);
		$('.menu-types').removeClass('expanded');

		if ($(window).width() < 1024) {

			$('.mobile-menu-toggle').text('Selected - '+ menu +' menu');

		};
	
	});

	$(document).on('click', '.j-menu-toggle', function(e){
	
		e.preventDefault();
		$(this).parent().toggleClass('expanded');
	
	});

	if ($(window).width() < 639) {

		$(document).on('click', '.j-location-toggle', function(e){
		
			e.preventDefault();
			$(this).parent().toggleClass('active').siblings().removeClass('active');
		
		});

		

	
      
      	var innerHeight = window.innerHeight;
		$('.home-carousel img').height(innerHeight);
		
	

	}

	if ($(window).width() < 1025) {

		  	var innerHeight = window.innerHeight;
		$('.home-carousel img').height(innerHeight);
		
	

	}

	// Set cookie for cookie policy modal

	var cookie_box = Cookies.get('cookie_box');

    if(cookie_box == undefined) {

    	console.log('cookie_box undefined');
    	setTimeout(function(){
    		$('.cookie-modal').removeClass('active');
    	}, 3000);

    }

	// Close cookie popup

	$(document).on('click', '.j-close-cookie-popup', function(e){

		e.preventDefault();
		$(this).parent().addClass('active');
		Cookies.set('cookie_box', 'true', { expires: 365 });

	});
  
  	if (document.location.href.indexOf('?about') > -1 ) {
      
      console.log('REACHED');
      $('.j-toggle-content').click();
      
    };

});